<template>
    <div class="header">
        <div class="header__inner">
            <router-link to="/logout" class="header__logout" v-tooltip="$helpers.uiText('U001')"
                >Logout</router-link
            >
            <a
                v-on:click.prevent="openSettings().catch(() => {})"
                href="#"
                class="header__settings"
                v-tooltip="$helpers.uiText('U002')"
                >Settings</a
            >
            <app-devicepicker></app-devicepicker>
            <button
                v-if="getUserDomainUrl"
                v-on:click.prevent="openLiveDomain"
                class="header__view"
                :disabled="getSessionCurrentlyPublishing"
                v-tooltip="'Gehe zu ' + getUserDomainUrl"
                v-html="$helpers.uiText('U003')"
            ></button>
            <button
                v-if="getUserDomainUrl"
                v-on:click.prevent="publishAllDataClientSide().catch(() => {})"
                class="header__save"
                :disabled="getSessionCurrentlyPublishing"
                v-tooltip="$helpers.uiText('U005')"
                v-html="$helpers.uiText('U004')"
            ></button>
        </div>
        <div class="header__debug" :class="{ 'header__debug--visible': debugVisible }">
            <ul>
                <li>
                    <span>{{ getProp('deha.user.email') }}</span>
                </li>
                <li>
                    <span>{{ hasPackageBasic ? 'Basic' : 'Starter' }}</span>
                </li>
                <li>
                    <a
                        v-on:click.prevent="saveAllData().catch(() => {})"
                        v-bind:class="{ disabled: !getSessionNotSaved }"
                        href="#"
                        >Save</a
                    >
                </li>
                <li>
                    <a
                        v-on:click.prevent=""
                        v-on:dblclick.prevent="resetData(1).catch(() => {})"
                        href="#"
                        >Reset to starter</a
                    >
                </li>
                <li>
                    <a
                        v-on:click.prevent=""
                        v-on:dblclick.prevent="resetData(2).catch(() => {})"
                        href="#"
                        >Reset to basic</a
                    >
                </li>
                <li>
                    <a
                        v-if="hasPackageStarter"
                        v-on:click.prevent=""
                        v-on:dblclick.prevent="changePackageRequest(2).catch(() => {})"
                        href="#"
                        >Request Upgrade to Basic</a
                    >
                </li>
                <li>
                    <a
                        v-if="hasPackageBasic"
                        v-on:click.prevent=""
                        v-on:dblclick.prevent="changePackageRequest(1).catch(() => {})"
                        href="#"
                        >Request Downgrade to Starter</a
                    >
                </li>
                <!--
                <li>
                    <router-link to="/render" target="_blank">Render</router-link>
                </li>
                <li>
                    <a v-bind:href="getUserDomainUrl" target="_blank">Live</a>
                </li>
                <li>
                    <a
                        v-on:click.prevent="undoSnapshot"
                        v-bind:class="{ disabled: isSnapshotFirst }"
                        href="#"
                        >&lt;</a
                    >
                </li>
                <li>
                    <a
                        v-on:click.prevent="redoSnapshot"
                        v-bind:class="{ disabled: isSnapshotLast }"
                        href="#"
                        >&gt;</a
                    >
                </li>
                -->
            </ul>
        </div>
    </div>
</template>

<script>
import Devicepicker from '@/components/assorted/Devicepicker.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            debugKeypressCount: 0,
            debugKeypressHiddenCount: 0,
            debugVisible: false
        };
    },
    components: {
        'app-devicepicker': Devicepicker
    },
    methods: {
        ...mapActions([
            'saveAllData',
            'publishAllDataClientSide',
            'undoSnapshot',
            'redoSnapshot',
            'resetData',
            'changePackageRequest',
            'openSettings'
        ]),
        openLiveDomain() {
            window.open(this.getUserDomainUrl);
        },
        debugKeypressListener(e) {
            // "aaaaa"
            if (
                this.getUserId.toString().indexOf('70000') > -1 ||
                this.getUserTestPeriod !== null
            ) {
                if (e.which == 97 || e.keyCode == 97) {
                    this.debugKeypressCount++;
                    if (this.debugKeypressCount >= 5) {
                        this.debugVisible = !this.debugVisible;
                        this.debugKeypressCount = 0;
                    }
                } else {
                    this.debugKeypressCount = 0;
                }
            }
            // "######################"
            if (e.which == 35 || e.keyCode == 35) {
                this.debugKeypressHiddenCount++;
                if (this.debugKeypressHiddenCount >= 22) {
                    this.debugVisible = !this.debugVisible;
                    this.debugKeypressHiddenCount = 0;
                }
            } else {
                this.debugKeypressHiddenCount = 0;
            }
        }
    },
    computed: {
        ...mapGetters([
            'getUserDomainUrl',
            'getUserId',
            'getUserTestPeriod',
            'getSessionNotSaved',
            'isSnapshotFirst',
            'isSnapshotLast',
            'getProp',
            'hasPackageStarter',
            'hasPackageBasic',
            'getSessionCurrentlyPublishing'
        ])
    },
    mounted() {
        document.addEventListener('keypress', this.debugKeypressListener);
    },
    beforeDestroy() {
        document.removeEventListener('keypress', this.debugKeypressListener);
    },
    created() {}
};
</script>
